<h1 mat-dialog-title>{{ 'friendRequests.manageDialog.title' | transloco }}</h1>

<mat-dialog-content>
  <div class="pending-invites">
    <h4>{{ 'friendRequests.manageDialog.pendingInvitesTitle' | transloco }}</h4>
    <p>
      {{ 'friendRequests.manageDialog.pendingInvitesDescription' | transloco }}
    </p>

    <div *ngIf="isLoadingPendingInvites" class="pending-invites-loading">
      <mat-progress-spinner diameter="36" strokeWidth="4" mode="indeterminate"></mat-progress-spinner>
    </div>

    <ng-container *ngIf="!isLoadingPendingInvites">
      <div *ngIf="pendingRequests.length > 0; else noPendingRequests" class="pending-invites-list">
        <div class="pending-invites-bulk-actions">
          <span></span>
          <mat-checkbox [checked]="isAllSelected()" [indeterminate]="hasSelectedRequests() && !isAllSelected()"
            (change)="toggleSelectAll()" [matTooltip]="'friendRequests.manageDialog.selectAll' | transloco"
            class="pending-invites-select-all">
          </mat-checkbox>
        </div>

        <mat-list>
          <mat-list-item *ngFor="let request of pendingRequests; trackBy: trackByRequestId" class="pending-invites-item">
            <span matListItemTitle>{{ request.senderOrganizationName }}</span>
            <div matListItemMeta class="pending-invites-actions">
              <button mat-icon-button color="primary" type="button" (click)="acceptRequest(request)"
                [disabled]="isRequestProcessing(request.id)"
                [matTooltip]="'friendRequests.manageDialog.acceptButton' | transloco">
                <mat-icon>check</mat-icon>
              </button>
              <button mat-icon-button color="warn" type="button" (click)="rejectRequest(request)"
                [disabled]="isRequestProcessing(request.id)"
                [matTooltip]="'friendRequests.manageDialog.rejectButton' | transloco">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <mat-checkbox matListItemMeta [checked]="isSelected(request.id)" (change)="toggleSelection(request.id)"
              [disabled]="isRequestProcessing(request.id)" class="pending-invites-checkbox">
            </mat-checkbox>
          </mat-list-item>
        </mat-list>
        <div class="pending-invites-bulk-buttons">
          <button mat-raised-button color="primary" type="button" (click)="acceptSelectedRequests()"
            [disabled]="!hasSelectedRequests()">
            <mat-icon>check</mat-icon>
            {{ 'friendRequests.manageDialog.acceptSelected' | transloco }}
          </button>
          <button mat-raised-button color="warn" type="button" (click)="rejectSelectedRequests()"
            [disabled]="!hasSelectedRequests()">
            <mat-icon>close</mat-icon>
            {{ 'friendRequests.manageDialog.rejectSelected' | transloco }}
          </button>
        </div>
      </div>

      <ng-template #noPendingRequests>
        <p class="pending-invites-empty-message">
          {{ 'friendRequests.manageDialog.noPendingInvites' | transloco }}
        </p>
      </ng-template>
    </ng-container>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <span style="flex: 1 1 auto;"></span>
  <button (click)="closeDialog()" mat-raised-button type="button">
    {{ 'common.buttons.close' | transloco }}
  </button>
</mat-dialog-actions>
